'use strict';
import * as $j_app$002edata$002e$002dGotenberg$002dSecret from "./app.data.-Gotenberg-Secret.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_GotenbergSecret$() {
  this.aBy = null;
  this.aBz = false;
}
export { $c_Lapp_data_GotenbergSecret$ as $c_Lapp_data_GotenbergSecret$ };
$p = $c_Lapp_data_GotenbergSecret$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_GotenbergSecret$;
/** @constructor */
function $h_Lapp_data_GotenbergSecret$() {
}
export { $h_Lapp_data_GotenbergSecret$ as $h_Lapp_data_GotenbergSecret$ };
$h_Lapp_data_GotenbergSecret$.prototype = $p;
$p.bNt = (function() {
  if ((!this.aBz)) {
    this.aBy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Codec$().hY, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((secret) => new $j_app$002edata$002e$002dGotenberg$002dSecret.$c_Lapp_data_GotenbergSecret(secret))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$1) => _$1.Y5)));
    this.aBz = true;
  }
  return this.aBy;
});
$p.bKK = (function(x$0) {
  return new $j_app$002edata$002e$002dGotenberg$002dSecret.$c_Lapp_data_GotenbergSecret(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKK(p);
});
var $d_Lapp_data_GotenbergSecret$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_GotenbergSecret$, "app.data.GotenbergSecret$", ({
  DM: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_GotenbergSecret$ as $d_Lapp_data_GotenbergSecret$ };
var $n_Lapp_data_GotenbergSecret$;
function $m_Lapp_data_GotenbergSecret$() {
  if ((!$n_Lapp_data_GotenbergSecret$)) {
    $n_Lapp_data_GotenbergSecret$ = new $c_Lapp_data_GotenbergSecret$();
  }
  return $n_Lapp_data_GotenbergSecret$;
}
export { $m_Lapp_data_GotenbergSecret$ as $m_Lapp_data_GotenbergSecret$ };
//# sourceMappingURL=app.data.-Gotenberg-Secret$.js.map
